import { useState, useEffect } from "react";

export const useCompanyStatsUI = () => {
  const [isOpenDateRange, setIsOpenDateRange] = useState(false);
  const [openModal, setOpenModal] = useState(null);

  const openModalByKey = (key) => {
    setOpenModal(key);
  };

  const closeModal = () => {
    setOpenModal(null);
  };

  useEffect(() => {
    if (openModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [openModal]);


  return {
    isOpenDateRange,
    openModal,

    openDateRange: () => setIsOpenDateRange(true),
    closeDateRange: () => setIsOpenDateRange(false),

    openModalByKey,
    closeModal,
  };
};
